import { useParams } from 'react-router'
import { Mtds } from 'prove-common'
import { ManualLocationRegistrationModal } from '../manuell-location-registration/ManualLocationRegistrationModal'
import { useState } from 'react'

type NoPosFoundErrorProps = {
  newSample?: boolean
  onSelectedLonLatChanged?: (lonLat: [number, number]) => void
  deferSave?: boolean
}

export const NoPosFoundError = ({
  newSample,
  onSelectedLonLatChanged,
  deferSave
}: NoPosFoundErrorProps) => {
  const [isManualModalOpen, setIsManualModalOpen] = useState(false)
  const { sampleId } = useParams()

  return (
    <Mtds.Alert data-color='danger' as={Mtds.Prose}>
      <Mtds.Heading>Kunne ikke finne posisjon</Mtds.Heading>
      <p>Denne oppgaven krever nøyaktig posisjon</p>
      <Mtds.Button
        data-variant='primary'
        onClick={() => {
          setIsManualModalOpen(true)
        }}
      >
        Legg til posisjon manuelt
      </Mtds.Button>
      {isManualModalOpen && (
        <ManualLocationRegistrationModal
          isManualModalOpen={isManualModalOpen}
          setIsManualModalOpen={setIsManualModalOpen}
          sampleId={sampleId}
          newSample={newSample}
          onSelectedLonLatChanged={onSelectedLonLatChanged}
          deferSave={deferSave}
        />
      )}
    </Mtds.Alert>
  )
}
